import React, { Component } from "react";
import { Table, Modal, Image } from "react-bootstrap";

import { appConfig } from "../../config";
var dateFormat = require("dateformat");
class ItemMasterView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const datas =
      this.props.ItemMasterDtls && this.props.ItemMasterDtls.item
        ? this.props.ItemMasterDtls && this.props.ItemMasterDtls.item
        : null;
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Item Master Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="Commondetlsmodelview">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td className="feedbkTdWdth"> Brand </td>
                        <td className="feedbkModalCap">
                          {datas !== null &&
                          datas.brand !== undefined &&
                          datas.brand.name ? (
                            datas.brand.name
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Brand not provided -
                            </span>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td> Item Name </td>
                        <td className="feedbkModalCap">
                          {" "}
                          {datas !== null && datas.drugName ? (
                            datas.drugName
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Item name not provided -
                            </span>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td> Item Code </td>
                        <td className="feedbkModalCap">
                          {" "}
                          {datas !== null && datas.drugCode ? (
                            datas.drugCode
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Item code not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Unit Cost </td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.unitCost ? (
                            datas.unitCost
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Unit cost not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Unit</td>
                        <td className="feedbkModalCap">
                          {datas !== null &&
                          datas.unitMeasure !== undefined &&
                          datas.unitMeasure.name ? (
                            datas.unitMeasure.name
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Unit not provided -
                            </span>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td> Unit Price </td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.unitPrice ? (
                            datas.unitPrice
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Unit price not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Tax Percentage </td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.taxPernct ? (
                            datas.taxPernct
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Tax percentage not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Tax Amount</td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.taxAmnt ? (
                            datas.taxAmnt
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Tax amount not provided -
                            </span>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td> MRP</td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.mrp ? (
                            datas.mrp
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -MRP not provided -
                            </span>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td> Medical Type</td>
                        <td className="feedbkModalCap">
                          {datas !== null &&
                          datas.medicalType !== null &&
                          datas.medicalType !== undefined &&
                          datas.medicalType.name ? (
                            datas.medicalType.name
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Medical type not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Remarks</td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.remarks ? (
                            datas.remarks
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Remarks not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Batch Number </td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.batchNo ? (
                            datas.batchNo
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Batch number not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Mfg Date</td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.mfgDate !== null ? (
                            dateFormat(datas.mfgDate, "mediumDate")
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Mfg date not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Expiry Date</td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.expiryDate !== null ? (
                            dateFormat(datas.expiryDate, "mediumDate")
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Expiry date not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> HSN Code </td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.hsnCode ? (
                            datas.hsnCode
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -HSN Code not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Description </td>
                        <td className="feedbkModalCap">
                          {datas !== null && datas.descp ? (
                            datas.descp
                          ) : (
                            <span style={{ fontStyle: "italic" }}>
                              -Description not provided -
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td> Created Date</td>
                        <td className="feedbkModalCap">
                          {datas !== null &&
                            datas.createdAt !== null &&
                            dateFormat(datas.createdAt, "mediumDate")}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ItemMasterView;
